import React from 'react';
import { useTranslation } from 'react-i18next';
import phonakAudeo from '../images/horapparater/ph-pic-audeoi-r-p6-witheasyguard-infiniosymbol-1920x1080.avif';
import phonakVirto from '../images/horapparater/Phonak_Virto-I-R_1.png';
import oticonIntent from '../images/horapparater/Oticon_Intent_miniRITE_H1-2024_Left_C090ChromaBeige_LEDgreen_Speaker60_OpenBassDome_1200x1200px_Original file.webp';
import oticonOwn from '../images/horapparater/Oticon_Own_SI_IIC_Right_C005Black_Angled_1200x1200px_Original file.webp';
import oticonZeal from '../images/horapparater/Oticon_Zeal.png';

const Horapparater: React.FC = () => {
  const { t } = useTranslation();

  const products = [
    {
      name: 'Phonak Audéo Infinio (Ultra) Sphere',
      brand: 'Phonak',
      image: phonakAudeo,
      description: 'Upplev oöverträffad taltydlighet i buller från alla riktningar med Infinio Ultra Sphere – gjord för att hjälpa dig att höra tydligt, även i de mest komplexa lyssningssituationerna. Har världens första dedikerade Al-chip för att separera tal från buller från alla riktningar. Spheric Speech Clarity 2.0 extraherar, förbättrar och integrerar tal från ett obegränsat antal röster i realtid för att leverera oöverträffad taltydlighet i buller från alla riktningar. Alltid universell. Bluetooth®-anslutning som fungerar – oavsett enhet, oavsett ögonblick. Kompatibel med Phonaks patenterade EasyGuard™-dome – skyddar dina hörapparater från vax, vilket gör det enklare än någonsin att sköta hörapparaten. Kraft som varar. Nu hela dagen lång med upp till 56 timmars batteritid*.'
    },
    {
      name: 'Phonak Virto I-R',
      brand: 'Phonak',
      image: phonakVirto,
      description: 'En ny era av ultra-anpassad hörselteknik är här – utformad för din komfort, stil och personliga ljudupplevelse. Fullt uppladdningsbara och universellt anslutna håller Phonak Virto R Infinio dig i takt med varje ögonblick, vart livet än tar dig. Genom att kombinera en innovativ design med Infinio Ultra-teknologin levererar Virto R Infinio enastående ljudkvalitet och tydlig taluppfattning, skräddarsydd för dig. Anpassad passform med RightFitTM för apparater så små som möjligt och som passar din komfort exakt, hela dagen. AutoSense OSTM 7.0 utnyttjar artificiell intelligens för att identifiera och automatiskt anpassa sig till dina lyssningsbehov i varje situation. Phonak SmartSpeech Technology ger 16 % bättre taluppfattning1 och 21 % mindre trötthet i slutet av dagen.'
    },
    {
      name: 'Oticon Intent miniRITE',
      brand: 'Oticon',
      image: oticonIntent,
      description: 'Oticon Intent är en diskret, laddbar hörapparat med telespole och lättanvänd tryckknapp. Den ger dig tillgång till ljud i 360° och använder kraftfulla sensorer som reagerar på dina lyssningsintentioner så att du kan engagera dig i livet som aldrig tidigare. Oticon Intent använder Bluetooth®-teknologi som stöder streaming och handsfree-samtal med hög ljudkvalitet. Hörapparaten bygger på BrainHearing™-teknologi som ger stöd till hjärnans naturliga sätt att ge mening åt ljud.'
    },
    {
      name: 'Oticon Zeal',
      brand: 'Oticon',
      image: oticonZeal,
      badge: 'Nyhet – Våren 2026',
      description: 'Oticon Zeal™ är världens mest diskreta och kompletta hörapparat. Tack vare innovativ inkapslingsteknik kombinerar den förstklassig AI-ljudbearbetning, komplett trådlös anslutning med Bluetooth® LE Audio och Auracast™, samt laddbart batteri med upp till 20 timmars användning – allt i en extremt kompakt och robust design (IP68). Oticon Zeal kan anpassas redan samma dag med flexibel utprovning via dome eller formgjuten insats, utan väntetider.'
    },
    {
      name: 'Oticon Own SI',
      brand: 'Oticon',
      image: oticonOwn,
      description: 'Oticon Own SI™ Invisible-in-the-Canal (IIC) placeras djupt in i hörselgången för den ultimata kombinationen av diskret design, överlägset ljud och komfort som räcker hela dagen. Hörapparaten bygger på BrainHearing™-teknologi som ger stöd till hjärnans naturliga sätt att ge mening åt ljud.'
    }
  ];

  return (
    <div className="bg-white">
      <div className="max-w-6xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-bold text-[#0A4A7A] mb-4">{t('horapparater.title')}</h1>
        <p className="text-xl text-gray-700 mb-8">{t('horapparater.subtitle')}</p>
        <p className="text-gray-700 text-lg mb-16 max-w-4xl">{t('horapparater.intro')}</p>

        <div className="space-y-16">
          {products.map((product, index) => (
            <div key={index} className="grid md:grid-cols-2 gap-8 items-center">
              <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                <img src={product.image} alt={product.name} className="w-full rounded-lg" />
              </div>
              <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                <p className="text-[#0A4A7A] font-medium mb-2">{product.brand}</p>
                <h2 className="text-2xl font-bold text-[#0A4A7A] mb-4">{product.name}</h2>
                {product.badge && <span className="inline-block bg-green-600 text-white text-sm font-semibold px-3 py-1 rounded mb-4">{product.badge}</span>}
                <p className="text-gray-700 mb-6">{product.description}</p>
                <a href="https://www.bokadirekt.se/places/varmdo-horsel-134414" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#0A4A7A] text-white px-6 py-3 rounded font-semibold hover:bg-[#083d66] transition-colors">
                  Boka tid
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Horapparater;
